import Label from '../../../ui/Label';
import Input from '../../../ui/Input';
import { useDispatch, useSelector } from 'react-redux';
import { addContactPerson, removeContactPerson, selectClientData, updateContactPerson } from '../../../../features/client/clientSlice';
import { Person } from '../../../../types/client';
import { useMutationData } from '../../../../hooks/api/useMutationData';
import ClientUpdateBtnWrap from './ClientUpdateBtnWrap';
import useClientAction from '../../../../hooks/actions/useClientAction';

interface ClientModalContactPersonProps {
    typeOfAction: 'newClient' | 'update'
}

export default function ClientModalContactPerson({ typeOfAction }: ClientModalContactPersonProps) {
    
    const { handleUpdateContactPerson, cancelUpdate, isContactPerson } = useClientAction()
    const dispatch = useDispatch()
    const clientData = useSelector(selectClientData);
    const contacts = clientData.contactPersons
    const { isLoadingUpdateClientInfo } = useMutationData()

    const contactSource: Person[] =
        typeOfAction === 'update'
            ? contacts
            : clientData.contactPersons;

    const allContactPersonList: Person[] =
        isContactPerson
            ? clientData.contactPersons
            : contactSource;

    return (
        <div className='py-2 space-y-2'>
            <div className='grid grid-cols-1 gap-2'>
                <Label label={'Additional Information:'} subLabel='(optional)'/>
            </div>
            {allContactPersonList?.map((person, index) => (
                <div key={index} className="grid grid-cols-1 md:grid-cols-2 gap-1 md:gap-2 lg:gap-3 items-start">
                    <div>
                        <Label label={`Contact Person ${index + 1}`}/>
                        <Input
                            type="text"
                            value={person.name}
                            onChange={(e) =>
                                dispatch(updateContactPerson({
                                    contactID: person.contactID,
                                    field: "name",
                                    value: e.target.value
                                }))
                            }
                            placeholder="Juan Dela Cruz"
                            disabled={typeOfAction === 'update' ? !isContactPerson : isContactPerson}
                        />
                    </div>

                    <div>
                        <div className='flex w-full justify-between'>
                            <Label label={`Contact Number`}/>
                            {typeOfAction === 'update' && allContactPersonList.length < 2 && index === 1 &&  (
                                <button
                                    type="button"
                                    className="text-red-600 block text-sm font-medium mb-1.5"
                                    onClick={() => dispatch(removeContactPerson(person.contactID))}
                                >
                                    Remove
                                </button>
                            )}
                            {typeOfAction === 'newClient' && index === 1 && (
                                <button
                                    type="button"
                                    className="text-red-600 block text-sm font-medium mb-1.5"
                                    onClick={() => dispatch(removeContactPerson(person.contactID))}
                                >
                                    Remove
                                </button>
                            )}
                            {allContactPersonList?.length === 1 && index === 1 && isContactPerson &&  (
                                <button
                                    type="button"
                                    className="text-red-600 block text-sm font-medium mb-1.5"
                                    onClick={() => dispatch(removeContactPerson(person.contactID))}
                                >
                                    Remove
                                </button>
                            )}
                        </div>
                        <Input
                            type="text"
                            value={person.number}
                            onChange={(e) => {

                                let value = e.target.value
                                if (!/^\d*$/.test(value)) return;
                                if (!value.startsWith("09")) {
                                    value = "09";
                                }
                                if (value.length > 11) return;
                                dispatch(updateContactPerson({
                                    contactID: person.contactID,
                                    field: "number",
                                    value: value
                                }))
                            }}
                            placeholder="09123456789"
                            maxLength={11}
                            disabled={typeOfAction === 'update' ? !isContactPerson : isContactPerson}
                        />
                    </div>
                </div>
            ))}

            {allContactPersonList.length !== 2 &&  typeOfAction === 'newClient' && (
                <div className="flex justify-start">
                    <button
                        type="button"
                        onClick={() => {
                            dispatch(addContactPerson())
                        }}
                        className="px-3 text-[12px] py-1 bg-cbColor text-white rounded hover:bg-cbColorDark transition"
                    >
                        + Add Contact Person
                    </button>
                </div>
            )}

            {/* <ClientModalActionPanel
                typeOfAction={typeOfAction}
                isLoadingUpdateAPI={isLoadingUpdateClientInfo}
                isUpdateData={isUpdateContactPerson}
                handleCancelUpdate={handleCancelUpdate}
                handleStartUpdate={handleStartUpdate}
                handleUpdateFinal={handleUpdateContactPerson}
                labelOne={'Saving...'}
                labelTwo={'Cancel'}
                labelThree={'Save'}
                labelFour={'Update additional information'}
            /> */}
            {typeOfAction === 'update' && (
                <div className='mt-2'>
                    <ClientUpdateBtnWrap
                        updateType="upAdditionalInformation"
                        isLoading={isLoadingUpdateClientInfo}
                        onSave={handleUpdateContactPerson}
                        onCancel={cancelUpdate}
                    />
                </div>
            )}
        </div>
    )
}
